import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from 'material-ui-icons/Info';
import {
  realexOfferRequestInformationMutation,
  investorOffersQuery,
  offerQuery,
} from '../../../apollo';
import RequestInformationAction from './RequestInformationAction';
import { DASHBOARD_OFFER_LIMIT as limit } from '../../../config';

const realexOfferRequestInformation = ({
  offerId,
  linkForm,
  realexRequestform,
}) => (
  <RequestInformationAction
    offerId={offerId}
    mutation={realexOfferRequestInformationMutation}
    refetchQueries={[
      {
        query: investorOffersQuery,
        variables: {
          query: {
            limit,
            skip: 0,
            sort: 'order',
            order: 'ASC',
            filter: {
              $or: [
                {
                  favorited: true,
                },
                {
                  requestedInformation: true,
                },
                {
                  readyToInvest: true,
                },
              ],
            },
          },
        },
      },
      {
        query: offerQuery,
        variables: {
          _id: offerId,
        },
      },
    ]}
    Icon={InfoIcon}
    title={'Request Information'}
    dialogBody={`Thank you for visiting. Based on the
    investment preferences you've provided this
    opportunity does not appear to be a suitable
    investment for you. If you would like more
    information, please submit a request to the
    banker.`}
    enableMessage
    realexRequestform={realexRequestform}
  />
);

realexOfferRequestInformation.propTypes = {
  offerId: PropTypes.string.isRequired,
  linkForm: PropTypes.bool,
  realexRequestform: PropTypes.bool,
};

export default realexOfferRequestInformation;



// WEBPACK FOOTER //
// ./src/components/RealexOffer/RealexRequestInformationButton/index.js